export const HOME_DATA_HERO = {
  en: {
    mainTitle: "Begin Your Guided Sessions",
    subTitle: "with Salah Al Rashed",
  },
  ar: {
    mainTitle: "ابدأ جلساتك",
    subTitle: "مع الدكتور صلاح الراشد",
  },
};

export const HOME_DATA_INFO_CARD = {
  en: {
    btnText: "Read More",
    startText: "Start",
    readMoreText: "Read more",
  },
  ar: {
    btnText: "اقرأ المزيد",
    startText: "بدء",
    readMoreText: "اقرأ المزيد",
  },
};

export const HOME_DATA_RIGHT_BAR = {
  en: {
    personalStats: "Personal Statistics",
    totalSessions: "Total sessions",
    thisMonth: "This month",
    mostUsedSession: "Most used session",
    sessionTranslation: "Sessions",
    
  },
  ar: {
    personalStats: " الإحصائيات الشخصية",
    sessionTranslation: "جلسات",
    totalSessions: "إجمالي الجلسات",
    thisMonth: "هذا الشهر",
    mostUsedSession: "أكثر جلسة استخدامًا",
  },
};

export const HOME_DATA_SESSION_TRACKER = {
  en: {
    sessionTrackerTitle: "Sessions Tracker",
    sessionTrackerSubTitle:
      "You've used {usedSessions} out of {totalSessions} sessions this month",
  },
  ar: {
    sessionTrackerTitle: "عدد الجلسات",
    sessionTrackerSubTitle:
      "لقد استخدمت {usedSessions} من أصل {totalSessions} جلسات هذا الشهر",
  },
};


export const HOME_DATA_PLAN_CARD = {
  en: {
    planCardTitle: "Your {planName} plan will end in {remainingDays} days",
    planCardSubTitle: "Upgrade to Premium",
    planCardExpiredTitle: "Your plan has expired",
  },
  ar: {
    planCardTitle: "سوف ينتهي اشتراكك {planName} خلال {remainingDays} يومًا",
    planCardSubTitle: "الترقية إلى الباقة المميزة",
    planCardExpiredTitle: "انتهى اشتراكك",
  },
};


export const HOME_DATA_READ_MORE = {
  en: {
    reviewsTitle: "Reviews",
    noReviews: "No reviews found",
  },
  ar: {
    reviewsTitle: " التقييمات",
    noReviews: "لا يوجد تقييمات",
  },
};

export const HOME_DATA_REVIEW_HISTORY = {
  en: {
    reviewHistoryTitle: "Session History",
    reviewHistorySubTitle:
      "You have completed this session {reviewCount} times",
    reviewHistoryItemDate: "Completed On",
    noRatings: "No ratings yet",
    btnText: ["Cancel", "Save Changes"],
    reviewAddedSuccessfully: "Review added successfully",
    reviewUpdatedSuccessfully: "Review edited successfully",
    reviewDeletedSuccessfully: "Review deleted successfully",
  },
  ar: {
    reviewHistoryTitle: "سجل الجلسات",
    reviewHistorySubTitle: "لقد أكملت هذه الجلسة {reviewCount} مرات",
    reviewHistoryItemDate: " تم الإكمال في",
    noRatings: "لا يوجد تقييمات",
    btnText: ["إلغاء", "حفظ التغييرات"],
    reviewAddedSuccessfully: "تمت إضافة التقييم بنجاح",
    reviewUpdatedSuccessfully: "تم تعديل التقييم بنجاح",
    reviewDeletedSuccessfully: "تم حذف التقييم بنجاح",
  },
};

export const HOME_DATA_SESSION_DETAILS = {
  en: {
    sessionDetailsTitle: "Session Details",
    startSessionBtnText: "Start Session",
    watchVideoBtnText: "Watch Video",
    pdfHeaderText: "Session Summary",
    pdfFooterText: "Generated on",
    btnText: ["Maybe Later", "Save Review"],
    generatingPdfText: "Generating PDF...",
    sendingRequestText: "Sending Request...",
    downloadedText: "Downloaded 😊",
    reviewAddedSuccessfully: "Review added successfully",
    reviewUpdatedSuccessfully: "Review edited successfully",
  },
  ar: {
    sessionDetailsTitle: "تفاصيل الجلسة",
    startSessionBtnText: " بدء الجلسة",
    watchVideoBtnText: "مشاهدة الفيديو",
    pdfHeaderText: "ملخص الجلسة",
    pdfFooterText: "تم التوليد في",
    btnText: ["ربما لاحقًا", "حفظ التغييرات"],
    generatingPdfText: "توليد PDF...",
    sendingRequestText: "إرسال الطلب...",
    downloadedText: "تم التحميل 😊",
    reviewAddedSuccessfully: "تمت إضافة التقييم بنجاح",
    reviewUpdatedSuccessfully: "تم تعديل التقييم بنجاح",
  },
};

